import { render, staticRenderFns } from "./ProxyRouteDetails.vue?vue&type=template&id=47e37107&scoped=true"
import script from "./ProxyRouteDetails.vue?vue&type=script&lang=js"
export * from "./ProxyRouteDetails.vue?vue&type=script&lang=js"
import style0 from "./ProxyRouteDetails.vue?vue&type=style&index=0&id=47e37107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e37107",
  null
  
)

export default component.exports